import "react-app-polyfill/ie11";
import "react-app-polyfill/stable";

import React from "react";
import ReactDOM from "react-dom";
import "./index.css";
import * as serviceWorker from "./serviceWorker";

import { Container } from "react-bootstrap";
import "bootstrap/dist/css/bootstrap.min.css";

import { faCheck, faTimes, faCircleNotch, faArrowLeft } from "@fortawesome/free-solid-svg-icons";
import { faDotCircle } from "@fortawesome/free-regular-svg-icons";
import { library } from "@fortawesome/fontawesome-svg-core";

import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import "style/bootstrap-custom.scss";
import { BrowserRouter as Router, Switch, Route, Redirect } from "react-router-dom";
import Routes from "Components/Routes";

import Header from "./Components/Header/Header";
import Footer from "./Components/Footer/Footer";
import Home from "./Components/Home/Home";
import ContactForm from "Components/ContactForm/ContactForm";

library.add(faCheck, faTimes, faDotCircle, faCircleNotch, faArrowLeft);
toast.configure();

ReactDOM.render(
  <React.StrictMode>
    <Router>
      <Header />
      <Container id="main-container" className="site-width flex-grow-1" fluid>
        <Switch>
          <Route exact path={Routes.home} component={Home} />

          <Route exact path={Routes.contact} component={ContactForm} />
          <Route>
            <Redirect to={Routes.home} />
          </Route>
        </Switch>
      </Container>
      <Footer />
    </Router>
  </React.StrictMode>,
  document.getElementById("app")
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
